export default __webpack_public_path__ + "static/media/artist-sm-square.55f53a57.jpg";